import React, {useEffect, useState} from "react";
import {
    Tr,
    Td,
    Flex,
    Text,
    Box,
    useColorModeValue,
    Button,
    Icon,
} from "@chakra-ui/react";

import {
    flexRender,
} from '@tanstack/react-table'
import {FaEye} from "react-icons/fa";
import {TiDelete, TiEdit} from "react-icons/ti";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {useAuthHeader} from "react-auth-kit";

function TableRatesRow(props) {
    const { row, setActive, approveDel, LimitId, id, respon } = props;
    const token = useAuthHeader();
    const textColor = useColorModeValue("gray.700", "white");
    const [details, setDetails] = useState(true)
    const [hasDelete, setDelete] = useState(true)
    const [hasEdit, setEdit] = useState(true)
    const navigate = useNavigate();
    let cells = row.getVisibleCells();

    const navigateToDetails = (id) => {
        if (details) {
            setDetails(false)
            navigate(`/admin_area/rates/${id}`, {replace: true});
        }
    };

    const navigateToEdit = (id) => {
        if (hasEdit) {
            setEdit(false)
            navigate(`/admin_area/rates/edit/${id}`, {replace: true});
        }
    };

    useEffect(() => {
        if (approveDel) {
            if (id !== ''){
                deleteRowRate(id)
            }
        }
    },[approveDel])

    useEffect(() => {
        document.body.style.overflowY = "hidden";
        return () => {
            document.body.style.overflowY = "scroll";
        };
    }, []);

    async function deleteRowRate(id) {
        if (hasDelete) {
            setDelete(false)
            setActive(true)
            LimitId(id)
            if (approveDel){
                const res = await deleteRate(id, token())
                if (res === 'deleted') {
                    setActive(true)
                    respon(res)
                    LimitId(null)
                }
            }

        }
    }

    return (
        <Tr>
            <Td key={cells[0].id}>
                <Flex alignItems="center" minWidth="100%" flexWrap="nowrap">
                    <Text fontSize="xs" color={textColor} fontWeight="bold">
                        {flexRender(
                            cells[0].column.columnDef.cell,
                            cells[0].getContext()
                        )}
                    </Text>
                </Flex>
            </Td>
            <Td  key={cells[1].id}>
                <Text fontSize="xs" color={textColor} fontWeight="bold">
                    {flexRender(
                        cells[1].column.columnDef.cell,
                        cells[1].getContext()
                    )}
                </Text>
            </Td>
            <Td key={cells[2].id}>
                <Text fontSize="xs" color={textColor} fontWeight="bold">
                    {flexRender(
                        cells[2].column.columnDef.cell,
                        cells[2].getContext()
                    )}
                </Text>
            </Td>
            <Td key={cells[3].id}>
                <Text fontSize="xs" maxW='100px' color={textColor} fontWeight="bold">
                    {flexRender(
                        cells[3].column.columnDef.cell,
                        cells[3].getContext()
                    )}
                </Text>
            </Td>
            <Td key={cells[4].id}>
                <Text fontSize="xs" maxW='100px' color={textColor} fontWeight="bold">
                    {flexRender(
                        cells[4].column.columnDef.cell,
                        cells[4].getContext()
                    )}
                </Text>
            </Td>
            <Td key={cells[5].id}>
                <Text fontSize="xs" color={textColor} fontWeight="bold">
                    {flexRender(
                        cells[5].column.columnDef.cell,
                        cells[5].getContext()
                    )}
                </Text>
            </Td>
            <Td key={cells[6].id}>
                <Text fontSize="xs" color={textColor} fontWeight="bold">
                    {flexRender(
                        cells[6].column.columnDef.cell,
                        cells[6].getContext()
                    )}
                </Text>
            </Td>
            <Td>
                <Flex>
                    <Box>
                        <Button
                            p="0px"
                            bg="transparent"
                            onClick={() => {
                                navigateToDetails(cells[2].getContext().row.original.id)
                                setDetails(true)
                            }}
                        >
                            <Icon w='15px' h='15px' as={FaEye} color="gray.400" cursor="pointer" />
                        </Button>
                    </Box>
                    <Box>
                        <Button
                            p="0px"
                            bg="transparent"
                            onClick={() => {
                                navigateToEdit(cells[2].getContext().row.original.id)
                                setEdit(true)
                            }}
                        >
                            <Icon w='15px' h='15px'
                                  as={TiEdit}
                                  color="grey.100"
                                  cursor="pointer"
                            />
                        </Button>
                    </Box>
                    <Box>
                        <Button
                            p="0px"
                            bg="transparent"
                            onClick={() => {
                                deleteRowRate(cells[2].getContext().row.original.id)
                                setDelete(true)
                            }}
                        >
                            <Icon w='15px' h='15px'
                                  as={TiDelete}
                                  color="red.400"
                                  cursor="pointer"
                            />
                        </Button>
                    </Box>
                </Flex>
            </Td>
        </Tr>
    );
}

export default TableRatesRow;


async function deleteRate(id, token) {
    try {
        const response = await axios.delete(`/api/v1/fx_rate/${id}`,
            {headers: {Authorization: token}})
        return await response.data
    } catch (e) {
        if (e.response) {
            console.log(e.response.data);
            console.log(e.response.status);
            return {}
        }
    }
}
